import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-request-confirm-identity',
  templateUrl: './request-confirm-identity.component.html',
  styleUrls: ['./request-confirm-identity.component.scss']
})
export class RequestConfirmIdentityComponent implements OnInit {
  data: string = '';

  constructor(
    public dialogRef: MatDialogRef<RequestConfirmIdentityComponent>,
    @Inject(MAT_DIALOG_DATA) public message: string,
    private sanitizer: DomSanitizer
  ) {
    dialogRef.disableClose = false;
    this.data = message;
  }

  ngOnInit(): void {}

  /** Đóng dialog, trả về false (Hủy bỏ / nút X) */
  onNoClick(): void {
    this.dialogRef.close(false);
  }
}